/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import CenteredSpinner from './CenteredSpinner';
import { useQuery } from 'react-query';
import { Button, Modal } from 'react-bootstrap';
import { VendorSearchModal } from './modals/VendorSearchModal';
import { useLocalStorage } from 'react-use';
import { toast } from 'react-toastify';


export const PropertyListingForm = () => {
  const location = useLocation();
  const [staffMemberId] = useState(localStorage.getItem('staffMemberId'));
  const [username] = useState(localStorage.getItem('username'));
  const [values, setValues] = useState({});
  const [name, setName] = useLocalStorage('name', '');
  const [surname, setSurname] = useLocalStorage('surname', '');
  const [passportnumber, setPassportNumber] = useLocalStorage('passportnumber', '');
  const [companyName, setCompanyName] = useLocalStorage('companyName', '');
  const [companyNameReg, setCompanyNameReg] = useLocalStorage('companyNameReg', '');
  const [addressType, setAddressType] = useLocalStorage('addressType', '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sigPad, setSigPad] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [emailShow, setEmailShow] = useState(false);
  const [emails, setEmails] = useState('');
  const [userId] = useState(localStorage.getItem('userId'));
  const [userEmail] = useState(JSON.parse(localStorage.getItem('staffMemberInfo')).mainEmail);
  const branchId = JSON.parse(localStorage.getItem('staffMemberInfo')).branchAccess[0]?.id;
  const [errorEmail, setErrorEmail] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    let token = localStorage.getItem('token');
    axios.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${token}`;

    document.title = 'Listing Form';
  }, []);

  useEffect(() => {
    if (isSubmitting) {
      postListingAgreement();
    }
  }, [isSubmitting, sigPad, values.signature]);

  useEffect(() => {
    setName(location?.state?.detail?.firstname);
    setSurname(location?.state?.detail?.surname);
    setPassportNumber(location?.state?.detail?.passportNumber);
    setCompanyName(location?.state?.detail?.companyName);
    setCompanyNameReg(location?.state?.detail?.companyNameReg);
    setAddressType(location?.state?.addressType);
    setEmails(location?.state?.detail?.email);
  }, [
    location?.state?.detail?.name,
    location?.state?.detail?.passportNumber,
    location?.state?.detail?.surname,
    location?.state?.detail?.companyName,
    location?.state?.detail?.companyNameReg,
    location?.state?.detail?.email,
    location?.state?.addressType,
    location?.state?.propertyId,
  ]);

  const fetchDocument = () => {
    const options = {
      method: 'GET',
      url: `/DocumentTemplate/GetPropertyListingAgreementForMobile/${location?.state?.propertyId}`,
    };

    return axios
      .request(options)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new Error('Server error');
      });
  };

  const postEmailMessage = () => {

    let data = {
      RecordId: parseInt(location?.state?.propertyId),
      Signature1: sigPad.toDataURL(),
      BranchId: branchId,
      BodyText: "xxx", //Set by backend
      CompanyId: 1, //Set by backend
      ContextId: 3, //Set by backend,
      Description: "xxx", //Set by backend
      SubjectText: "xxx", //Set by backend
      TemplateType: 1, //Set by backend
      StaffMemberId: staffMemberId,
      EmailMessage: {
        message: dataDocument?.bodyText, //Overwritten by backend
        sys_UserId: userId,
        toAddress: emails,
        fromAddress: userEmail,
        subject: 'Listing Agreement Signed', //Overwritten by backend
      }
    };

    const config = {
      method: 'POST',
      url: '/DocumentTemplate/PostEmailMessageForAgreement',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    };

    return axios
      .request(config)
      .then((response) => {
        toast.success(`Email Sent`, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return response.data;
      })
      .catch((error) => {
        toast.error(`Internal Server Error, please contact support.`, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: false,
          progress: undefined,
        });
      });
  };

  const {
    isLoading: isLoadingDocument,
    data: dataDocument,
    isError,
  } = useQuery(['document'], fetchDocument, {
    refetchOnWindowFocus: false
  });

  const getCurrentDate = () => {
    let d = new Date();
    let date = d.getDate();
    let month = d.getMonth() + 1;
    let year = d.getFullYear();
    let hour = d.getHours();
    let minutes = d.getMinutes();

    return `${month}/${date}/${year} ${hour}:${minutes}`;
  };

  const goBack = () => {
    navigate('/');
  };

  const email = () => {
    setEmailShow(true);
  };


  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    setIsSubmitting(true);
  };

  const handleModalShowHide = () => {
    setModalShow(false);
  };

  const handleChangeEmail = (e) => {
    setErrorEmail('');
    setEmails(e.target.value);
  };

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSubmitEmail = (event) => {
    event.preventDefault();
    let emailsAddresses = emails.split(';');
    let txt = '';
    let email = [];
    for (let x in emailsAddresses) {
      txt = validateEmail(emailsAddresses[x]);
      email.push(txt);
    }

    if (!emails) {
      setErrorEmail('Email is required');
      return;
    }

    if (emailsAddresses.length > 1 && email.includes(false)) {
      setErrorEmail(
        'There is an error in one of the email addresses.',
      );
      return;
    }

    if (email.includes(false)) {
      setErrorEmail('Invalid email address.');
      return;
    }

    setEmailShow(false);
    let elements = emailsAddresses.join(';');
    postEmailMessage();
  };

  const handleClearSignature = () => {
    sigPad.clear();
  };

  const trim = () => {
    setSigPad({
      trimmedDataURL: sigPad
        .getTrimmedCanvas()
        .toDataURL('image/png'),
    });
  };

  const postListingAgreement = async (e) => {
    let data = {
        RecordId: parseInt(location?.state?.propertyId),
        Signature1: sigPad.toDataURL(),
        BranchId: branchId,
        BodyText: "xxx", //Set by backend
        CompanyId: 1, //Set by backend
        ContextId: 3, //Set by backend,
        Description: "xxx", //Set by backend
        SubjectText: "xxx", //Set by backend
        TemplateType: 1, //Set by backend
        Username: username
      };

    const config = {
      method: 'POST',
      url: '/DocumentTemplate/PostPropertyListingAgreement',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    };

    try {
      const data = await axios(config);
      if (data.status == 200 || data.status == 201) {
        toast.success(
          `Listing Agreement Saved`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
        navigate('/');
      }
    } catch (err) {
      setIsSubmitting(false);
        toast.error(
          `Internal Server Error, please contact support.`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
    }
  };

  if (isLoadingDocument) {
    return <CenteredSpinner />;
  }

  if (isError) {
    return (
      <div className="container">
        <div className="row justify-content-center align-items-center vh-100">
          <h1>Server is down, please try again later </h1>
        </div>
      </div>
    );
  }
  return (
    <div className="container pt-3 pb-4 property-form-page">
      <div className="card shadow-sm border-0 overflow-hidden property-list-card">
        <div className="property-list-hero d-flex align-items-center px-4 py-3">
          <div className="property-list-hero-icon d-flex align-items-center justify-content-center">
            <i className="fas fa-file-signature" aria-hidden="true"></i>
          </div>
          <div className="ml-3">
            <p className="mb-1 text-uppercase text-white-50 small">Listing Agreement</p>
            <h4 className="mb-0 text-white listing-agreement-title">{dataDocument?.description}</h4>
          </div>
          <button
            type="button"
            className="btn btn-light btn-sm ml-auto property-list-back"
            onClick={() => navigate(-1)}
          >
            <i className="fas fa-arrow-left me-2"></i>
            Back
          </button>
        </div>
        <div className="p-4">
          <form onSubmit={handleSubmit} id="validation-form">
            <div className="property-details-card mb-3">
              <h6>Owner details</h6>
              {addressType === 'false' ? (
                <>
                  <div className="form-group">
                    <label className="property-details-label" htmlFor="name">
                      Owner's First Name
                    </label>
                    <input
                      id="name"
                      className="form-control d-block w-100"
                      type="text"
                      name="name"
                      value={name}
                      placeholder="John"
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label
                      className="property-details-label"
                      htmlFor="surname"
                    >
                      Owner's Surname
                    </label>
                    <input
                      id="Surname"
                      className="form-control d-block w-100"
                      type="text"
                      name="surname"
                      value={surname}
                      placeholder="Doe"
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label
                      className="property-details-label"
                      htmlFor="passport"
                    >
                      Owner's ID/Passport
                    </label>
                    <input
                      id="passport"
                      className="form-control d-block w-100"
                      type="text"
                      name="passportNumber"
                      value={passportnumber}
                      placeholder="0585856M"
                      disabled
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="form-group">
                    <label
                      className="property-details-label"
                      htmlFor="companyName"
                    >
                      Company's Name
                    </label>
                    <input
                      id="companyName"
                      className="form-control d-block w-100"
                      type="text"
                      name="companyName"
                      value={companyName}
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label
                      className="property-details-label"
                      htmlFor="companyNameReg"
                    >
                      Company's reg no.
                    </label>
                    <input
                      id="companyNameReg"
                      className="form-control d-block w-100"
                      type="text"
                      name="companyNameReg"
                      value={companyNameReg}
                      disabled
                    />
                  </div>
                </>
              )}
            </div>

            <div className="property-details-card mb-3">
              <h6>Agreement</h6>
              <div
                className="property-form-document"
                dangerouslySetInnerHTML={{
                  __html: dataDocument?.bodyText,
                }}
              ></div>
            </div>

            <div className="property-details-card mb-3">
              <h6>Owner signature</h6>
              <SignatureCanvas
                penColor="blue"
                backgroundColor="white"
                clearOnResize={false}
                canvasProps={{
                  height: 500,
                  className: 'sigPad property-signature-pad w-100',
                }}
                ref={(ref) => {
                  setSigPad(ref);
                }}
              />
              <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between mt-3" style={{ gap: '12px' }}>
                <button
                  type="button"
                  className="btn property-secondary-btn"
                  onClick={handleClearSignature}
                >
                  Clear signature
                </button>
                <div className="property-form-timestamp">
                  {getCurrentDate()}
                </div>
              </div>
            </div>

            <div className="property-form-actions d-flex flex-column flex-sm-row align-items-stretch justify-content-between">
              <button
                type="button"
                className="btn property-secondary-btn mb-2 mb-sm-0"
                onClick={email}
              >
                Email
              </button>
              <button
                type="submit"
                className="btn property-primary-btn"
              >
                Save
              </button>
            </div>

            <Modal show={modalShow} backdrop="static" centered dialogClassName="property-modal">
              <Modal.Header
                closeButton
                onClick={handleModalShowHide}
              >
                <Modal.Title>
                  <span className="font-weight-bold">Agreement Saved</span>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <i
                    className="fa fa-check-circle fa-5x mb-3"
                    aria-hidden="true"
                  ></i>
                  <p>
                    Thanks {name} {surname}
                  </p>
                  <p>
                    Property Listing Agreement form stored
                    successfully
                  </p>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={goBack}>
                  Home
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal show={emailShow} backdrop="static" centered dialogClassName="property-modal">
              <Modal.Header
                closeButton
                onClick={() => setEmailShow(false)}
              >
                <Modal.Title><span className='font-weight-bold'>Send Agreement Email</span></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>
                  Please enter the email addresses you would like to
                  send the property listing form to
                </p>
                <div className="form-group">
                  <label className="property-details-label" htmlFor="emails">
                    Emails
                  </label>
                  <input
                    id="emails"
                    autoComplete="off"
                    className={`form-control ${
                      errorEmail && 'border-danger'
                    } d-block w-100 mb-2`}
                    type="text"
                    name="emails"
                    value={emails}
                    onChange={handleChangeEmail}
                    required
                  />
                  {errorEmail && (
                    <small className="text-danger">
                      {errorEmail}
                    </small>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={handleSubmitEmail}>
                  Send
                </Button>
              </Modal.Footer>
            </Modal>
          </form>
        </div>
      </div>
    </div>
  );
};
